module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cn"
  }, [_vm._v("Procurement and Output")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Goodall became DNC, the Admiralty warship procurement system was much the same as it had been since 1920. The normal process for ordering British warships in the 1930s was:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" Naval Staff perceive the need for a new (class of) warship, to meet new threats or to replace old ships.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" After internal Admiralty departmental discussions coordinated by Director of Training & Staff Duties, a Staff Requirement is sent to the Director of Naval Construction to prepare sketch designs.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" Designs with estimated costs reviewed by the Controller and Staff.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" Preferred design submitted by Assistant Chief of Naval Staff to the Admiralty Board, if affordable. If accepted and with Treasury approval, detailed design prepared. Brief particulars and estimated costs included in forthcoming annual Navy Estimates presented to Parliament each March.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" Tenders issued to suitable shipbuilders on Admiralty list, together with design drawings and specifications prepared by DNC department.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" Tenders received by Admiralty (typically one to two months later), reviewed by DNC, Director of Contracts and Engineer in Chief, including a check that prices looked reasonable.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" Recommendation via Controller to Board of Admiralty on shipbuilder(s) selected.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_vm._v("•")]), _vm._v(" Hull and machinery orders placed with shipbuilder and engine builder by Director of Contracts. Sometimes phased to give a regular pattern of expenditure throughout the financial year (monies voted but not spent could not at that time be carried forward to the next year).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The contract covered the hull and machinery only, as at the same time the Admiralty placed separate orders for the armament, armour plating and other Admiralty Supply Items (ASIs) such as fire-control equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("As rearmament got underway, strategic considerations and the Treasury Inter-Service Committee played a greater role in priorities for defence expenditure. When it came to shipbuilding expenditure at that time, what the Admiralty was not fully aware of was that the main warship builders were operating a price-fixing scheme. A Warship Builders Committee had been formed by their trade association The Shipbuilding Conference to ensure that loss-making tenders were not submitted for British warships. This Committee reviewed the tenders which the various builders were about to submit, placed them in cost order and then added what they regarded as an adequate profit margin to each. The prices submitted were thus in a competitive order but high enough to offset some of the losses they had been making on merchant-ship contracts. By so doing they were inadvertently maintaining a core of warship-building skills and capacity which would be desperately needed once war came. This arrangement resulted in some high profit margins for some ships as discussed on page 196.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the war, operational demands and resource limitations drove procurement rather than international politics and finance. The Admiralty Board proposed the types and numbers of vessels to be built, notionally under an annual programme, for approval by the War Cabinet and the Treasury. They had to bear in mind the limited shipbuilding manpower and materials available, which were also required for merchant ships and ship repairing. But in view of the urgency, it was more important to place the hull and machinery contracts wherever the resources existed, rather than go through a lengthy tendering process. Goodall, with input from his Director of Warship Production on current workloads and labour levels plus his own assessment of the competence of the various shipbuilders, was able to advise Controller where orders for the next batch of ships should be placed. Once Controller had given his approval, DNC would advise the selected shipbuilders of the forthcoming order, to be followed up by a formal letter from the Director of Contracts. Specifications and design drawings would be sent as soon as possible to allow shipbuilders to order materials.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A provisional price was proposed by the Admiralty to form the basis of contract stage payments. There could be a hundred or more such ‘milestones’ during construction, at which the specified percentage would be paid. From about 1942, the final price paid to the shipbuilder (and machinery builder) was based on the actual costs of labour, materials and overheads, plus any extras as a result of Admiralty changes during building. A profit margin would then be added, typically 7 per cent of costs, to give a final price. But negotiations of all the details and changes meant that a final figure might not be agreed until a year or more after a "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("ship’s completion. While this was essentially a ‘cost plus’ system, it was not a blank cheque for the shipbuilder. Not only could Admiralty accountants challenge costs which differed significantly from other shipbuilders, but a group of ships would be costed as a whole. Thus for all the destroyers of a flotilla an average cost would be worked out on which the associated profit margin was based. That price would be paid to all the builders in the group, resulting in a lower actual profit for a high-cost builder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("RCNC staff were used to progress the contracts. The Director of Warship Production was concerned with delivery of the overall programme, accelerating or deferring ships as required. The Director of Contract Work focussed on financial aspects, cost estimates and claims to determine what should be paid to contractors and sub-contractors. The Superintendent of Contract Work was concerned with progress, inspection and modifications to ships being built. Other issues concerned labour availability and transfers between shipyards, liaison with other Admiralty departments and priorities. Each region had a Warship Production Superintendent to implement the policies. Under him each warship builder had a Principal Ship Overseer as the Admiralty representative. He and his staff had to check that all the materials and equipment arriving in the yard were up to specification and tests. He was empowered to approve minor changes to the ship, but major drawings and proposed suppliers (e.g. of forgings) were sent to headquarters for approval, which also helped achieve commonality across sister ships built in other yards. His experience enabled him to clarify Admiralty intent to the contractor and he was able to advise of modifications to be incorporated. Standards of workmanship at the building berth and fitting out were checked, and compartments signed off when completed. Regular progress reports were submitted along with any problems such as shortage of particular shipyard trades. He had to check the shipyard’s preparations for the launch. He could also recommend that the Admiralty finance new equipment for the shipyard, e.g. more welding plant. The Admiralty was handicapped in this respect by getting only 6 per cent of fixed capital allocated for war production, nearly all of which went to the Air Ministry, War Office and Ministry of Supply.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("A recurring theme throughout the diaries is a shortage of labour for shipbuilding. Indeed the Admiralty as a whole had many fewer workers producing for it than the other services. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Statistical Digest of the War")]), _vm._v(" shows that even at its peak in 1943, the Admiralty had only about 597,000 compared with 1,678,000 for the Ministry of Aircraft Production and 1,318,000 for the Ministry of Supply (Army and munitions generally). Their share was thus only about 17 per cent out of a total of about 3.4 million. Of the Admiralty total, less than half was for shipbuilding "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("and repair, the balance being for machinery, ordnance and other naval equipment. At its peak in September 1943, the figures showed (Buxton 1998):")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1c"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Naval Vessels")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1c"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thousands")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Private yards, new work")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_vm._v("89.3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Repair & conversion")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_vm._v("44.1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Royal Dockyard")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_vm._v("36.7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Total naval")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("170.1")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Merchant Vessels")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Private yards, new work")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_vm._v("42.9")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Repair & conversion")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_vm._v("59.5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Total merchant")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("102.4")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Total new work")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_vm._v("135.2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Total repair")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_vm._v("137.3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Overall total")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tabr"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("272.5")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Warship work constituted about 62 per cent of the total. Unlike before the war where ship repair was largely maintenance work, during the war damage repair and conversion work dominated, with repair labour now exceeding newbuilding. The UK’s modest level of resources of about 270,000 workers for shipbuilding compares with about 1.6 million at its peak in the USA, six times greater. Although US productivity in tons per man was only about half that of the UK, reflecting the lower average level of skill, nevertheless its overall output was much larger. For warships it was about twice as great (1940–5 4.7 million tons displacement vs. 2.4 million) as well as being faster in production. For merchant ships the figures were about 38 million gross tons vs. 6 million, reflecting the huge output of standard ships like Liberties (Fassett 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The chart shows RN naval vessel completions from 1939 to 1945, adapted from Buxton (1998). The often-overlooked landing craft made up 20 per cent of the total. Annual output peaked at half a million tons, ten times the average of interwar warship production. The peak years were about one-third higher than those of the First World War, despite fewer shipyards and fewer workers. This was due to better control of shipbuilding resources by the Government and higher productivity. These figures exclude mercantile types, built or converted, such as escort carriers, repair ships, oilers, stores vessels, tugs and dockyard craft. Nearly all the vessels were designed under Goodall as DNC so are a measure of his work. They total 7,235 vessels of 2.522 million tons standard displacement. "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("However they exclude ‘his’ ships provided by the Admiralty to Allied navies such as destroyers and corvettes. The full line shows total tonnage from the British Shipbuilding Database, which is very similar. This does include Allied vessels, but excludes small vessels under about 100 tons such as MTBs, MLs and minor landing craft, large in number but small in aggregate tonnage. That total is 2,893 vessels of 2.618 million tons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Goodall’s frequent visits to shipyards and his diary entries show that he had a much higher opinion of some warship builders than others. From his comments, I assess his ratings would have been:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Good: John Brown, Cammell Laird, Vickers Armstrongs Barrow, Yarrow.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("Average: Harland & Wolff, Swan Hunter, Vickers Armstrongs Tyne, Hawthorn Leslie, Stephen, Denny, Thornycroft, White.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("Poor: Fairfield, Scotts.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18500dae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter03.vue
// module id = 87
// module chunks = 0